import PropTypes from "prop-types";
import { getTransactionTabComponent, TRANSACTION_TABS } from "pages/transaction/transactionTabs";

export default function TransactionsTabsPanel({ activeTabId, onTabChange }) {
  const activeTab = TRANSACTION_TABS.find((tab) => tab.id === activeTabId) || TRANSACTION_TABS[0];
  const ActiveTabComponent = getTransactionTabComponent(activeTabId);

  return (
    <section className="rounded-xl border border-slate-200 bg-white shadow-card">
      <div className="border-b border-slate-200 px-3 py-2">
        <div className="flex flex-wrap gap-2">
          {TRANSACTION_TABS.map((tab) => {
            const isActive = tab.id === activeTabId;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => onTabChange(tab.id)}
                className={`rounded-lg px-2 py-2 text-sm font-semibold transition ${
                  isActive
                    ? "bg-brand-900 text-white"
                    : "border border-slate-200 bg-white text-text-700 hover:bg-slate-50"
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="min-w-0 p-4 md:p-6">
        <h3 className="mb-4 text-lg font-semibold text-text-900">{activeTab.label}</h3>
        <ActiveTabComponent />
      </div>
    </section>
  );
}

TransactionsTabsPanel.propTypes = {
  activeTabId: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
};
